const MIME_TYPES = {
  pdf: 'application/pdf',
  csv: 'text/csv',
  jpeg: 'image/jpeg',
  png: 'image/png',
  txt: 'text/plain',
  json: 'application/json',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

export function getFilenameFromContentDispositionHelper(response) {
  const disposition = response.headers['content-disposition'];
  let filename;
  if (disposition && disposition.includes('attachment') && disposition.includes('filename=')) {
    const [, filenameStr] = disposition.split('filename=');
    filename = filenameStr.replaceAll('"', '');
  }
  return filename;
}

export function downloadFileHelper(data, filename) {
  if (!filename) return;
  // extract file mimetype
  const dotIndex = filename.lastIndexOf('.');
  const fileExtension = dotIndex !== -1 ? filename.slice(dotIndex + 1) : 'txt';
  const fileMimeType = MIME_TYPES[fileExtension];

  // create blob and download
  const link = document.createElement('a');
  const blob = new Blob([data], { type: fileMimeType });
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
